import React from 'react';
import Helper from '../../helper';

const PanelFeedbackItemComponent = ({subject,user_name,state,feedback_date,id, toggleDetail, educationCategory, feedback, duration, participant,education_id}) => (
    <div className="table-item" onClick={() => {toggleDetail({subject,user_name,state,feedback_date,id,educationCategory,duration,feedback,participant,education_id},true)}} >
        <div className="td-item t-1">
            <i className={"icon-feedback"}></i>
            <p>{Helper.titleCase(subject)}</p>
        </div>
        <div className="td-item t-2">
            <p>{participant?participant.name_surname:user_name}</p>
        </div>
        <div className="td-item t-3">
            <p>{state}</p>
        </div>
        <div className="td-item t-3 resp-date">
            <p>{feedback_date}</p>
        </div>
    </div>
);

export default PanelFeedbackItemComponent;